import PT from 'prop-types';
import React from 'react';

import DisabledFeatureAlert from '~/components/Shared/DisabledFeatureAlert/DisabledFeatureAlert';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import ListItems from '~/ui/components/ListItems/ListItems';
import Text from '~/ui/components/Text/Text';

function ContactIntegrationMessage({
  description,
  disabledFeatureDescription,
  enableIcon = false,
}) {
  const intl = useIntl();

  const defaultMessage = intl.formatMessage({
    id: 'ContactIntegrationMessage.disabledFeatureDescription',
    defaultMessage:
      'This integration is not currently enabled for your account.',
    description: 'Default message for disabled feature description',
  });

  return (
    <ListItems alignItems="center" columns={2} space={12}>
      <Text color="gray-800" variant="s-dense">
        {description}
      </Text>
      <FlexLayout alignItems="center" space={4}>
        <DisabledFeatureAlert
          description={disabledFeatureDescription ?? defaultMessage}
          enableIcon={enableIcon}
        />
      </FlexLayout>
    </ListItems>
  );
}

ContactIntegrationMessage.propTypes = {
  description: PT.string.isRequired,
  disabledFeatureDescription: PT.string,
  enableIcon: PT.bool,
};

export default ContactIntegrationMessage;
